import { useSelector } from "react-redux";
import { FooterContent } from "./FooterContentStack";
import DynamicContent  from '../../pages/DynamicPage/DynamicContent'

const Footer = (props) => {
  const theme = useSelector((state) => state.configuration.site.theme);
  const siteSetting = useSelector((state) => state.configuration.site.settings);
  const { children, preFooter } = props;
  const contentStack = children?.filter(
    (child) =>
      !["cetRibbon", "cetCopyright"].includes(
        child.props.el.contentElementTypeCode
      )
  );
  const contentStack1 = contentStack?.filter(
    (child) => !["Footer Shop Menu"].includes(child.props.el.contentElementName)
  );
  const ribbonMenu = children?.filter((child) =>
    ["cetRibbon"].includes(child.props.el.contentElementTypeCode)
  );
  let formElement = children?.find((child) =>
    ["cetForm"].includes(child.props.el.contentElementTypeCode)
  );
  if (!formElement?.props?.el?.formQuestions[0]) formElement = null;

  // prettier-ignore
  const logo = (theme?.footerLogoTarget === "Alternate") ? (theme?.footerLogoTarget === "None") ? "" : theme.additionalLogo : theme.logo;
  
  return (
    <>
      <div className="footer no-print col-12">
          <DynamicContent contentElements={preFooter} />
      </div>

      <footer className="footer no-print col-12">
        <FooterContent
          siteSetting={siteSetting}
          contentStack1={contentStack1}
          ribbonMenu={ribbonMenu?.[0]}
          logo={logo}
          theme={theme}
          contentStack={contentStack}
          formElement={formElement}
        />
      </footer>
    </>
  );
};

export { Footer };
